import { render, staticRenderFns } from "./OnlinePaymentConfirm.vue?vue&type=template&id=2a0c6f67"
import script from "./OnlinePaymentConfirm.vue?vue&type=script&lang=js"
export * from "./OnlinePaymentConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports